export function toTwoColumnOptions<T>(options: T[]): T[] {
  const columnLength = Math.ceil(options.length / 2);
  return options.slice(0, columnLength).reduce<T[]>((displayOptions, option, index) => {
    if (index >= columnLength) {
      return displayOptions;
    }

    const rightColumnOption = options[index + columnLength];
    return rightColumnOption
      ? [...displayOptions, option, rightColumnOption]
      : [...displayOptions, option];
  }, []);
}
